<template>
    <div :class="[$style.badge, {[$style.user]:badgeType=='user'}, {[$style.faculty]:badgeType=='faculty'}]"/>
</template>

<script>
export default {
    props: {
        badgeType: {
            type: String,
            required: true
        }
    }
}
</script>

<style module>
.badge{
    border-radius: 50%;
    width: 30px;
    height: 30px;
}

.user{
    background-color: #05A4C0;
}

.faculty{
    background-color: #FFC322;
}
</style>